import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Navigation } from "../../../../models/navigation";
import { LinkKeepUTM } from "../../../../shared/components/LinkKeepUTM";
import { Header } from "../../../../shared/components/header";
import { useFilterPagination } from "../../../../shared/hooks/useFilterPagination";
import { NewTaskIcon } from "../../../../shared/icons/newTaskIcon";
import { RootState } from "../../../../store";
import {
  getParticipantCompletedTODOService,
  getParticipantTODOService,
} from "../../../../todos/service";
import { TaskCard } from "../components/taskCard/taskCard";
import { TasksFilter } from "../components/tasksFilter/tasksFilter";
import { TasksTabs } from "../components/tasksTabs/tasksTabs";
import { useStyles } from "./list-tasks.styles";

type Props = {
  navigation?: Navigation[];
};

export const ListTasks = ({ navigation }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const small = useMediaQuery(theme.breakpoints.down("sm"));

  const userProfileId = useSelector<RootState, string>(
    (state) => state.profile.participantProfileId
  );

  const {
    infiniteRef,
    sourceData,
    totalDataRecords,
    debouncedHandleSortChange,
    debouncedHandleFilterChange,
    request,
  } = useFilterPagination(
    getParticipantTODOService,
    50,
    "taskId",
    undefined,
    userProfileId,
    undefined
  );

  const {
    infiniteRef: completedInfiniteRef,
    sourceData: completedSourceData,
    totalDataRecords: completedtotalDataRecords,
    debouncedHandleSortChange: completedDebouncedHandleSortChange,
    debouncedHandleFilterChange: completedDebouncedHandleFilterChange,
  } = useFilterPagination(
    getParticipantCompletedTODOService,
    50,
    "taskId",
    undefined,
    userProfileId,
    undefined
  );

  const { isDone } = request;

  const [selectedTab, setSelectedTab] = useState("allTasks");

  const initialFilters = { focusAreaId: -1, sortBy: "-1", Completed: "" };

  const [filters, setFilters] = useState(initialFilters);

  const [completedFilters, setCompletedFilters] = useState(initialFilters);

  const tasksPerView = 20;

  const [newTasksToLoad, setNewTasksToLoad] = useState(tasksPerView);

  const loadMoreTasks = () => {
    setNewTasksToLoad(newTasksToLoad + tasksPerView);
  };

  const tasksContent = (content) => {
    if (content.length > 0) {
      return content
        .slice(0, newTasksToLoad)
        .map(({ title, description, dueDate, completed, score, todoId }) => (
          <TaskCard
            key={todoId}
            title={title}
            description={description}
            dueDate={dueDate}
            completed={completed}
            score={score}
            todoId={todoId}
          />
        ));
    }
    if (content.length <= 0 && isDone) {
      return (
        <Grid item className={classes.noTasksMessage}>
          You don&apos;t have any tasks for now.
        </Grid>
      );
    }
    return (
      <div className={classes.loader}>
        <CircularProgress />
      </div>
    );
  };

  const createTaskButton = () => {
    if (small) {
      return (
        <IconButton to="/participant/createTodo" component={LinkKeepUTM}>
          <NewTaskIcon />
        </IconButton>
      );
    }
    return (
      <Button
        to="/participant/createTodo"
        component={LinkKeepUTM}
        className={classes.createTaskButton}
        endIcon={<AddIcon className={classes.createTaskIcon} />}
      >
        Create Task
      </Button>
    );
  };

  const loadMoreButton = (data) => {
    return (
      newTasksToLoad <= data.length && (
        <Button className={classes.loadMoreButton} onClick={loadMoreTasks}>
          Load more
        </Button>
      )
    );
  };

  return (
    <>
      <Header navigation={navigation}>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={classes.header}
        >
          <Typography className={classes.sectionTitle}>Tasks</Typography>
          <Grid item>
            <Grid container>{createTaskButton()}</Grid>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={10} sm={6} lg={12} className={classes.tabsItem}>
            <TasksTabs
              completedInfiniteRef={completedInfiniteRef}
              completedTasks={completedtotalDataRecords}
              allInfiniteRef={infiniteRef}
              allTasks={totalDataRecords}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />
          </Grid>
          <Grid item xs={2} sm={6} lg={12}>
            <TasksFilter
              debouncedHandleFilterChange={
                selectedTab === "Completed"
                  ? completedDebouncedHandleFilterChange
                  : debouncedHandleFilterChange
              }
              debouncedHandleSortChange={
                selectedTab === "Completed"
                  ? completedDebouncedHandleSortChange
                  : debouncedHandleSortChange
              }
              filters={selectedTab === "Completed" ? completedFilters : filters}
              setFilters={
                selectedTab === "Completed" ? setCompletedFilters : setFilters
              }
            />
          </Grid>
        </Grid>
        <Grid
          container
          ref={infiniteRef as React.RefObject<HTMLDivElement>}
          spacing={4}
          className={classes.tasksContainer}
          component="div"
        >
          {tasksContent(
            selectedTab === "Completed" ? completedSourceData : sourceData
          )}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          {loadMoreButton(
            selectedTab === "Completed" ? completedSourceData : sourceData
          )}
        </Grid>
      </Header>
    </>
  );
};

ListTasks.defaultProps = {
  navigation: [],
};
